import { h, Component } from 'preact';
import Store from 'store/store';

import { joinClasses } from 'utils/utils';
import { a11yCopy } from 'utils/copy';
import { track } from 'utils/tracking';

import Tiktok from 'components/bolt/icons/tiktok';
import Youtube from 'components/bolt/icons/youtube';
import Instagram from 'components/bolt/icons/instagram';
import Facebook from 'components/bolt/icons/facebook';
import Twitter from 'components/bolt/icons/twitter';

import s from 'components/shareIcons/shareIcons.sss';

export default class ShareIcons extends Component {

	constructor(props) {
		super(props);

		const urls = Store.get().appData?.meta?.social;
		this.links = [
			{ id: 'tiktok', name: 'TikTok', url: urls?.tiktok, icon: <Tiktok height="24" /> },
			{ id: 'youtube', name: 'YouTube', url: urls?.youtube, icon: <Youtube height="24" /> },
			{ id: 'instagram', name: 'Instagram', url: urls?.instagram, icon: <Instagram height="24" /> },
			{ id: 'facebook', name: 'Facebook', url: urls?.facebook, icon: <Facebook height="24" /> },
			{ id: 'twitter', name: 'X', url: urls?.twitter, icon: <Twitter height="24" /> }
		].filter(link => link.url);

		this.onClickHandler = this.onClickHandler.bind(this);
	}

	onClickHandler(e) {
		const type = this.props.type;
		if (!['header', 'footer', 'subscribe'].includes(this.props.type)) return;
		const id = e.currentTarget?.dataset?.type || e.currentTarget?.href;
		track('social', `${type}_social_follow`, `${type} - ${id}`);
	}

	renderLink(link) {
		return <a href={link.url} target="_blank" rel="noopener noreferrer" data-type={link.id} title={a11yCopy('$SOCIAL_ICONS_LINK', { platform: link.name })} onClick={this.onClickHandler} key={link.id}>{link.icon}</a>;
	}

	render(props) {
		return (
			<div class={joinClasses(s.wrapper, props.class)}>
				{this.links.map(link => this.renderLink(link))}
			</div>
		);
	}

}